import { api } from '../../api';
import { WebsiteStore, websitesStore } from './WebsitesStore';
import { IRawWebsite } from '../types';
import { notification } from 'antd';
import { AbstractFacade } from '../../shared';

export class WebsitesFacade extends AbstractFacade {
  constructor(readonly store: WebsiteStore) {
    super(store);
  }

  create = (model: IRawWebsite) =>
    this.doRequest(async () => {
      const res = await api.websites.create(model);

      if (res.response) {
        this.store.add(res.response);
      }

      return res;
    });

  update = (id: string, model: IRawWebsite) =>
    this.doRequest(async () => {
      const res = await api.websites.create(model);

      if (res.response) {
        this.store.replace(id, res.response);
      } else {
        notification.open({
          type: 'error',
          message: 'Error',
          description: 'Ooops, sometthing went wrong. Please, try again later.',
        });
      }

      return res;
    });

  delete = (id: string) =>
    this.doRequest(async () => {
      const res = await api.websites.remove(id);

      if (res.response) {
        console.error(this.store);
        this.store.remove(id);
      }

      return res;
    });

  loadAll = () =>
    this.doRequest(async () => {
      const res = await api.websites.load();

      if (res.response) {
        console.error(res.response);
        this.store.set(res.response);
      }

      return res;
    });

  getWebsiteCode = (id: string) =>
    this.doRequest(async () => {
      const res = await api.websites.generateToken(id);

      if (res.response) {
        this.store.update(id, (state) => {
          state.token = res.response!.token;
        });
      }

      return res;
    });

  setActiveWebsite(id: string | null) {
    this.store.setActive(id);
  }
}

export const facade = new WebsitesFacade(websitesStore);
